<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form :model="model"
                   :klassiekmodel="klassiekmodel"
                   :modellichtintegratie="modellichtintegratie"
                   :invloedspercentages="invloedspercentages"
                   :modelklassiekeuren="modelklassiekeuren"
                   :isEditing="true">
        </item-form>
    </div>
    <div v-else class="midden">
        <div style="color: #20a8d8; font-size: large;">Even geduld a.u.b.</div>
        <fadeloader :loading="loading" :size="size" :color="color" class="spinner2"></fadeloader>
    </div>
</template>

<script>
    import api from '../../api/afdelingteelt';
    import ItemForm from './FormSamenvatting';
    import FadeLoader from 'vue-spinner/src/FadeLoader';

    export default {
        data () {
            return {
                errormsg: '',
                model: { },
                klassiekmodel: { },
                invloedspercentages: { },

                modellichtintegratie: { },  // deze twee zijn toegevoegd voor energie
                modelklassiekeuren: { },

                loading: true,
                size: '20px',
                color: '#20a8d8',
            };
        },
        created () {
            this.getData(this.$route.params.id);
        },
        methods: {
            getData (id) {
                api.getSamenvatting(id).then((response) => {
                    this.model = response.data.lichtintegratie.model;
                    this.klassiekmodel = response.data.klassiek.model;
                    this.invloedspercentages = response.data.lichtintegratie.invloedspercentages;
                });
                api.getKlassiekebelichting(id).then((response) => {     // toegevoegd voor energie
                    this.modelklassiekeuren = response.data.model;
                });
                api.getWerkelijkebelichting(id).then((response) => {    // toegevoegd voor energie
                    this.modellichtintegratie = response.data.lichtintegratie.model;
                });
            },
        },
        components: {
            'item-form': ItemForm,
            fadeloader: FadeLoader,
        },
    };
</script>

<style>

    .spinner {
        margin-top: 30px;
        margin-bottom: 20px;
        margin-left:130px;
        color: #20a8d8;
    }

    .spinner2 {
        margin-top: 30px;
        margin-left:75px;
        color: #20a8d8;
    }

    .midden {
        width: 150px;
        height: 100px;

        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        margin: auto;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/ShowSamenvatting.vue